import { render, staticRenderFns } from "./EditCanned.vue?vue&type=template&id=385cce11&"
import script from "./EditCanned.vue?vue&type=script&lang=js&"
export * from "./EditCanned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports